/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:22:17 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

// add your real api resource name mapping here (resource_name: api_name)
export default {
  // user: 'User',
  admin: 'Admin',
  help: 'Help',
  evidence: 'Evidence',
  plot: 'Plot',
  plotSuspect: 'PlotSuspect',
  plotEvidence: 'PlotEvidence',
  event: 'Event',
  location: 'Location',
  eventEvidence: 'EventEvidence',
  eventSuspect: 'EventSuspect',
  eventSuperSleuth: 'EventSuperSleuth',
  template: 'Template',
  feedback: 'Feedback',
  user: 'User'
};
